import { Component, Input, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { AsyncPipe, Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable } from 'rxjs';

import { MessageActions } from 'src/app/common/store/actions/message.actions';
import { SearchActions } from 'src/app/common/store/actions/search.actions';
import { selectCurrentCar, selectCurrentCarImagesDatas, selectLoggedInUserDataId, selectDealerFavorites, selectSameSellerCarBriefs, selectSimilarCarBriefs, selectSearchFetchingResults, selectAuthLoggedIn } from 'src/app/common/store/state/app.state';

import { FilesActions } from 'src/app/common/store/actions/files.actions';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { DomSanitizer } from '@angular/platform-browser';
import { CarEditDialogComponent } from '../car-edit/car-edit.component';
import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay';
import { MatCalendar } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DealerType } from 'src/app/public/account/constants/dealer-basic-data';
import { ProposalDialogComponent } from 'src/app/public/buy/elements/proposal-dialog/proposal-dialog.component';
import { NumberDialogComponent } from 'src/app/public/common/components/number-dialog/number-dialog.component';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { ObjectClass } from 'src/app/public/common/constants/common-basic-data';
import { ObjectSource, GeneralBasicData, Currency } from 'src/app/public/common/constants/general-basic-data';
import { AppointmentDialogComponent } from 'src/app/public/common/elements/appointment-dialog/appointment-dialog.component';
import { MessageDialogComponent } from 'src/app/public/common/elements/message-dialog/message-dialog.component';
import { FileData } from 'src/app/public/common/models/file-data.model';
import { Message } from 'src/app/public/common/models/message.model';
import { ObjectData } from 'src/app/public/common/models/object-data.model';
import { Price } from 'src/app/public/common/models/string-data.model';
import { BookingDialogComponent } from 'src/app/public/rent/elements/booking-dialog/booking-dialog.component';
import { CarBusinessLine } from '../../constants/car-basic-data';
import { CarBrief } from '../../models/car-brief.model';
import { Car } from '../../models/car.model';
import { MatExpansionModule } from '@angular/material/expansion';
import { CarBoxListComponent } from '../car-box-list/car-box-list.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';


@Component({
    selector: 'app-car-details',
    templateUrl: './car-details.component.html',
    styleUrls: ['./car-details.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatProgressSpinnerModule, MatIconModule, MatDividerModule, CdkOverlayOrigin, CdkConnectedOverlay, AsyncPipe, MatExpansionModule, CarBoxListComponent, RouterLink, MatProgressBarModule]
})
export class CarDetailsComponent implements OnInit {

  @Input() businessLine?: CarBusinessLine;

  currentCar$: Observable<Car>;

  similarCarBriefs$: Observable<CarBrief[]>;
  sameSellerCarBriefs$: Observable<CarBrief[]>;

  similarCarBriefs: CarBrief[] = [];
  sameSellerCarBriefs: CarBrief[] = [];
  
  currentUserId$: Observable<string>;
  currentUserId: string = "";

  loggedIn$: Observable<boolean>;
  loggedIn: boolean = false;

  car: Car = new Car();

  carId: string = '';
  offerId: string = '';
  
  carImagesFolder$: Observable<FileData[] | undefined > ;

  carImagesFolder: FileData[] = [];

  currentImageIndex: number = 0;

  currentImageIndexSubject$: BehaviorSubject<number>;

  currentImage: any
  currentDealerImage: any
  
  isSeller: boolean = false;

  favorites: string[] = [];

  fetchingImage: boolean = true;

  // queryParams$: Observable<any>; 
  // routeParams$: Observable<any>;

  DealerType = DealerType;
  CarBusinessLine =  CarBusinessLine;
  showDetails: boolean = false;

  sectionId: string = "seller";
  ratingIndicators = Array(5).fill(1);

  fetchingResults$: Observable<boolean>;

  //objectSource: ObjectSource = GeneralBasicData.getObjectSource(this.businessLine!)
  objectSource = ObjectSource.DETAILS
   
  constructor(

    private store: Store, 
    private router: Router, 
    public route: ActivatedRoute,
    private readonly sanitizer: DomSanitizer,
    public dialog: MatDialog,
    private _location: Location
    ) {

      this.fetchingResults$ = store.select(selectSearchFetchingResults);
      
      this.currentImageIndexSubject$ = new BehaviorSubject<number>(0);
      this.currentUserId$ = store.select(selectLoggedInUserDataId);

      this.loggedIn$ = store.select(selectAuthLoggedIn);
      
      this.currentCar$ = store.select(selectCurrentCar);

      this.similarCarBriefs$ = store.select(selectSimilarCarBriefs);
      this.sameSellerCarBriefs$ = store.select(selectSameSellerCarBriefs);
      
      //this.carImagesFolder$ = store.select(selectImagesFolderByCarId(this.carId));
      
      this.carImagesFolder$ = store.select(selectCurrentCarImagesDatas);

      // this.queryParams$ = store.select(selectQueryParams);
      // this.routeParams$ = store.select(selectRouteParams);

    }

  ngOnInit(): void {

    this.currentUserId$ = this.store.select(selectLoggedInUserDataId);
    this.currentCar$ = this.store.select(selectCurrentCar);

    this.currentCar$.subscribe(
      (c: Car) => {
        this.currentImageIndex = 0;
        this.car = Object.assign(new Car(), c);
        this.carId = c.carId;
        this.offerId = c.offerId;
        this.isSeller = (this.currentUserId !== "" && this.currentUserId === this.car.providerId); 

        //this.store.dispatch(SearchActions.fetchSameSellerCarBriefsSubmit({sellerId: c.sellerId, businessLine: this.businessLine! }));

      });

    this.carImagesFolder$.subscribe(
      (imgdts) => {
          this.carImagesFolder = imgdts!;
          this.currentImage = this.getCarImage(0);
      });

    this.currentUserId$.subscribe(
      (userId: string) =>  {
        this.currentUserId = userId;
        this.isSeller = (userId !== "" && userId === this.car.providerId);
      }
    );

    this.loggedIn$.subscribe(
      (logged: boolean) =>  {
        this.loggedIn = logged
      }
    );

    this.currentImageIndexSubject$.subscribe(
      (i: number) =>  {
        this.currentImage = this.getCarImage(i);
      }
    );
    //similarCarBriefs: CarBrief[] = [];
    //sameSellerCarBriefs: CarBrief[] = [];

    this.similarCarBriefs$.subscribe(
      (res: CarBrief[]) =>  {
        this.similarCarBriefs = res.map(c => Object.assign(new CarBrief(), c));
      }
    );

    this.sameSellerCarBriefs$.subscribe(
      (res: CarBrief[]) =>  {
        this.sameSellerCarBriefs = res.map(c => Object.assign(new CarBrief(), c));
      }
    );

    this.currentImage = this.getCarImage(0);
    //this.store.dispatch(SearchActions.fetchSimilarCarsSubmit({carId: this.carId}));

    this.route.queryParams.subscribe(params => {

      this.offerId = params['offerId'] == undefined ? '' : params['offerId'];
      this.carId = params['carId'] == undefined ? '' : params['carId'];

      //console.log(this.offerId+" ffff "+this.carId)
    
      if(this.carId !== '' || this.offerId !== ''){

        console.log(this.offerId+" ffff "+this.carId)

        this.store.dispatch(SearchActions.fetchCarDetailsAndImagesSubmit({ carId: this.carId, offerId: this.offerId, businessLine: this.businessLine! }));
        this.store.dispatch(SearchActions.fetchSimilarCarBriefsSubmit({carId: this.carId, offerId: this.offerId, businessLine: this.businessLine! }));
        this.store.dispatch(SearchActions.fetchSameSellerCarBriefsSubmit({sellerId: this.car.providerId, businessLine: this.businessLine! }));
      }        
    });

    this.objectSource 

  }

  ngOnChanges(changes: SimpleChanges): void {
    
    const latestImagesFolder = changes['carImagesFolder'];
    if (latestImagesFolder != undefined) {
      if ((latestImagesFolder.currentValue?.length as number) === 1) {
        
        this.currentImageIndexSubject$.next(0);
      }
    }
  }

  moneyFormat(s: string): string{
    return AppFunctions.numberWithSpaces(s);
  }

  dateFormat(dt: string): string{

    return AppFunctions.stringToDatetime(dt);
  }

  createImageFromBlob(imageData: Blob): any {
    let objectUrl = URL.createObjectURL(imageData);     
    return this.sanitizer.bypassSecurityTrustUrl(objectUrl);    
  }

  getCarImage(i: number): any{

    if(this.carImagesFolder != undefined && this.carImagesFolder.length > 0 ){
      let objectUrl = URL.createObjectURL(this.carImagesFolder[i].blob);     
      return this.sanitizer.bypassSecurityTrustUrl(objectUrl); 
    }
  }

  openAppointmentDialog(): void {
      
    //console.log('index = '+JSON.parse(JSON.stringify(prop!)));
    let objectData: ObjectData = new ObjectData(GeneralBasicData.getObjectSource(this.businessLine!), this.car.offerId, 0);

    const dialogRef = this.dialog.open(AppointmentDialogComponent, {
      data: objectData
    });
  }

  openMessageDialog(): void {

    let msg = new Message();
    msg.senderId = this.currentUserId;

    console.log(" hgghgh "+this.currentUserId);
    //msg.senderId = "heyy"
    //return;
    
    const dialogRef = this.dialog.open(MessageDialogComponent, {
      data: msg
    });

    dialogRef.afterClosed().subscribe((result: any) => {

      //console.log('New price = '+result+ " car Id = "+carId);
      if(result != undefined ){
        console.log(result);
        result.receiverId = this.car.providerId;
        result.carId = this.car.carId;
        result.offerId = this.car.offerId;
        msg.senderId = ""
        console.log(result)
        this.store.dispatch(MessageActions.sendNewMessageSubmit( { message: result, objectSource: this.objectSource }));
      }  
    });
  }

  openOfferDialog(carId: string): void {
    let amount = 0;
    
    const dialogRef = this.dialog.open(NumberDialogComponent, {
      data: {amount: amount, label: "Offer"}
    });

    dialogRef.afterClosed().subscribe((result: number) => {
      console.log('New offer = '+result+ " car Id = "+carId);

      if(result > 0 )
        this.store.dispatch(DealerActions.createNewCarOfferSubmit( {carId: carId, amount: result }));
    });
  }

  openCarEditDialog(): void {

    const dialogRef = this.dialog.open(CarEditDialogComponent, {
      data: Object.assign(new Car(), this.car)
    });

    dialogRef.afterClosed().subscribe((result: any) => {

      if(result != undefined ){
        //console.log(result)
        
        if(result.id === ''){
          this.store.dispatch(DealerActions.createNewCarSubmit({ car: result }));
        }
        else{
          this.store.dispatch(DealerActions.updateCarSubmit({ carUpdates: result }));
        }
      }    
    });
  }

  openPriceDialog(carId: string): void {
    let amount = 0
    const dialogRef = this.dialog.open(NumberDialogComponent, {
      data: {amount: amount, label: "Price"}
    });

    dialogRef.afterClosed().subscribe((result: number) => {
      //console.log('New price = '+result+ " car Id = "+carId);
      if(result > 0 )
        this.store.dispatch(DealerActions.createNewCarPriceSubmit( {carId: carId, businessLine: this.businessLine!, price: new Price(result, Currency.XAF, 0) }));
    });
  }

  nextImage(): void{
    console.log("current = "+this.currentImageIndex);

    if(this.currentImageIndex === this.carImagesFolder!.length-1)
      this.currentImageIndex = 0;
    else 
      this.currentImageIndex++;
    console.log("next = "+this.currentImageIndex);
    this.currentImageIndexSubject$.next(this.currentImageIndex);
  }

  prevImage(): void{
    console.log("current ="+this.currentImageIndex);
    if(this.currentImageIndex === 0 )
      this.currentImageIndex = this.carImagesFolder!.length-1;
    else 
      this.currentImageIndex--;
    
    console.log("prev ="+this.currentImageIndex);
    this.currentImageIndexSubject$.next(this.currentImageIndex);
  }

  selectImage(index: number): void{
    this.currentImageIndex = index;
    this.currentImageIndexSubject$.next(this.currentImageIndex);
  }

  uploadImage(carId: string, event: any, ): void {

    let files: File[] = event.target.files;
    console.log('file name = '+files[0].name);

    if(files != undefined && files.length > 0){
      this.store.dispatch(FilesActions.uploadCarImageSubmit({ carId: carId, file: files[0] }));
    }
  }

  // isFavorite(carId: string): boolean{

  //   let isFav = false;
  //   if(this.favorites != undefined)
  //   isFav = (carId === this.favorites.find(x => x === carId))!;
    
  //   return isFav;
  // }

  toggleFavorite(): any{

    this.store.dispatch(DealerActions.toggleFavoriteSubmit( { objectId: this.car.offerId !== "" ? this.car.offerId : this.car.carId, objectClass: this.car.offerId !== "" ? ObjectClass.OFFER : ObjectClass.CAR, makeFav: !this.car.favorite, businessLine: this.businessLine!}))
  }

  goToCustomerPage(){

    switch(this.businessLine!.toString()){

      case CarBusinessLine.BUY.toString(): {
        this.router.navigate(
          //['/customer/buy-ongoing'],
          ['/buy-in/favorites'],
          { fragment: this.car.offerId }
          //{ queryParams: { carId: this.car.carId, offerId: this.car.offerId } }
        );
        break;
      }

      case CarBusinessLine.RENT.toString(): {
        this.router.navigate(
          //['/customer/rent-ongoing'],
          ['/rent-in/favorites'],
          { fragment: this.car.offerId }
          //{ queryParams: { carId: this.car.carId, offerId: this.car.offerId } }
        );
        break;
      }
    } 
  }

  goToProviderPage(){

    switch(this.businessLine!.toString()){

      case CarBusinessLine.BUY.toString(): {
        this.router.navigate(
          //['/provider/buy-ongoing'],
          ['/sell/offer'],
          { queryParams: { carId: this.car.carId, offerId: this.car.offerId } }
        );
        break;
      }

      case CarBusinessLine.RENT.toString(): {
        this.router.navigate(
          //['/provider/rent-ongoing'],
          ['/rent-out/offer'],
          { queryParams: { carId: this.car.carId, offerId: this.car.offerId } }
        );
        break;
      }
    } 
  }

  goToProposalOrBooking(){

    switch(this.businessLine!.toString()){

      case CarBusinessLine.BUY.toString(): {
        this.openProposalDialog();
        break;
      }

      case CarBusinessLine.RENT.toString(): {
        this.openBookingDialog();
        break;
      }
    } 
  }

  openProposalDialog(): void {

    let objectData: ObjectData = new ObjectData(GeneralBasicData.getObjectSource(this.businessLine!), this.car.offerId, 0);

    const dialogRef = this.dialog.open(ProposalDialogComponent, {
      data: objectData
    });
  }

  openBookingDialog(): void {

    //let objectData: ObjectData = new ObjectData(GeneralBasicData.getObjectSource(this.businessLine!), this.car.offerId, 0);

    let objectData: ObjectData = new ObjectData(this.objectSource, this.car.offerId, 0, CarBusinessLine.RENT, this.car.carId);

    const dialogRef = this.dialog.open(BookingDialogComponent, {
      data: objectData
    });
  }

  

  goToSellerPage(sellerId: string): any{

    this.router.navigate(
      ['/provider-public'],
      { queryParams: { id: sellerId } }
    );
  }

  goToCarEditPage(carId: string){

    this.router.navigate(
      ['/sell'],
      { queryParams: { id: carId} }
      );
  }

  goBackToSearchPage(){
    this.router.navigate(
      ['/buy'],
      {  }
    );
  }

  goToHomePage(){
    this.router.navigate(
      ['/buy'],
      {  }
    );
  }

  goToPreviousPage(){
    this._location.back();
  }

  stringify(obj: any){
    return JSON.stringify(obj);
  }
  getCountryName(code: string){
    return GeneralBasicData.getCountryNameByCode(code);
  }

  getRatingsTotalCount(): number{
    return AppFunctions.getArraySum(this.car.providerRatingsSummary.counts);
  }

  getSellerRatingsTotalCount(): number{
    return this.car.providerRatingsSummary.counts == null ? 0 : this.car.providerRatingsSummary.counts!.reduce((a, b) => a + b, 0);
  }

  // selectCarPrice(): Price{

  //   switch(this.businessLine!.toString()){

  //     case CarBusinessLine.BUY.toString(): {
  //       return this.car.buyPrice;
  //     }

  //     case CarBusinessLine.RENT.toString(): {
  //       return this.car.rentPrice;
  //     }

  //     default: {
  //       return Price.getDefault();
  //     }

  //   }
  // }
}

